import React, { useEffect, useState } from 'react';

const PromoBanner = () => {
  const [subHeader, setSubHeader] = useState(""); // State to hold the sub_header content
  const [isVisible, setIsVisible] = useState(true); // State to control visibility of the banner

  // Fetch the sub_header content from the API
  const fetchSubHeader = async () => {
    try {
      const response = await fetch(
        "https://backend.printtrio.co.uk/api/home/get-setting"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch the promo settings.");
      }

      const data = await response.json();

      // Check if the API response is successful and contains sub_header
      if (data.success && data.data.length > 0) {
        const fetchedSubHeader = data.data[0]?.sub_header;

        if (fetchedSubHeader) {
          setSubHeader(fetchedSubHeader); // Set the sub_header content
          setIsVisible(true); // Show the banner if content exists
        } else {
          setIsVisible(false); // Hide the banner if sub_header is null
        }
      } else {
        setIsVisible(false); // Hide the banner if response is not successful
      }
    } catch (error) {
      console.error("Error fetching sub_header:", error);
      setIsVisible(false); // Hide the banner on error
    }
  };

  // Fetch content when the component mounts
  useEffect(() => {
    fetchSubHeader();
  }, []);

  return (
    <>
      {isVisible && (
        <div className="w-full bg-pink-500 px-4 xl:px-20 relative">
          <div className="text-center py-2">
            <p className="text-white text-sm sm:text-xxs">{subHeader}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default PromoBanner;
